<template>
    <div>
        <my_menu2 v-if="project_name" :page_name="'个税核算 - ' + project_name" back_type="close" back_icon="md-close">
        </my_menu2>
        <div style="height:50px"></div>
        <div class="divmain">

            <div class="divleft">

                <Alert type="warning">重要提示：请确保员工归属税务局准确，上传数据后会将员工数据同步到国税！不是同一税所的的请分批进行。</Alert>

                <div class="title_1">
                    1、选择公司主体与税务局
                </div>
                <div class="select_cascader">
                    <Cascader filterable :data="subject_data" v-model="select_subject" style="width:100%"
                        @on-change="cascader_change" />
                </div>
                <div class="title_1">
                    2、选择算税年月
                </div>
                <div class="year_month_div">
                    <DatePicker v-if="year_month" disabled :model-value="year_month" type="month"
                        placeholder="Select month" style="width: 150px" />

                </div>
                <div class="title_1">
                    3、选择个税核算类型
                </div>
                <div class="year_month_div">
                    <RadioGroup v-model="cesuan_type" @on-change="cesuan_type_change">
                        <Radio label="工资薪金"></Radio>
                        <Radio label="全年一次性奖金"></Radio>
                        <Radio label="劳务报酬"></Radio>
                    </RadioGroup>
                </div>
                <div class="title_1">
                    4、上传个税模板表格
                </div>
                <div class="upload_box">
                    <div v-if="upload_url">
                        <Upload v-if="upload_object_name == ''" :action="upload_url" :on-success="success_upload"
                            :on-error='upload_error' :show-upload-list='false' :on-progress='upload_progress'>
                            <Button :disabled="select_subject.length != 2"
                                icon="ios-cloud-upload-outline">上传个税计算表</Button>
                        </Upload>
                        <div v-else class="upload_object_card">
                            <div>
                                文件：{{ upload_file_filename }}
                            </div>
                            <div>
                                测算ID：{{ cesuan_id }}
                            </div>
                            <div>
                                <span class="view_upload_file" @click="click_upload_file">查看</span>
                                <span class="view_upload_file" style="margin-left:10px"
                                    @click="del_upload_file">删除</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <Button disabled="true" icon="ios-cloud-upload-outline">请先选择主体</Button>
                    </div>
                    <div class="template_div">
                        <span @click="click_download_template(0)" class="template_name">
                            <Icon type="ios-cloud-download-outline" />工资薪金模板下载
                        </span>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span @click="click_download_template(1)" class="template_name">
                            <Icon type="ios-cloud-download-outline" />全年一次性奖金模板下载
                        </span>
                         <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span @click="click_download_template(2 )" class="template_name">
                            <Icon type="ios-cloud-download-outline" />劳务报酬模板下载
                        </span>
                    </div>
                </div>

                <div class="submit_div">
                    <Button :loading="suanshui_loading" type="primary" @click="click_suanshui">提交到算税队列</Button>
                </div>

                <div class="title_record">
                    <div class="title_record_left">
                        <div class="title_icon">
                        </div>
                        个税核算历史记录
                    </div>


                    <div>
                        <Button size="small" style="font-size: 13px;" type="warning" @click="add_change_name_people">
                            <Icon type="md-add" />改姓名员工报备
                        </Button>
                    </div>
                </div>
                <Alert type="success">小知识：个税是动态的，由税务局实时计算，每月至少算一次，核算与发薪间隔时间久的也尽量重新核算一下。</Alert>


                <div style="padding:5px 10px;">
                    <Table size="small" :columns="columns" :data="table_data" :height="windowHeight - 480">
                        <template #detail="{ row }">
                            <div class="detail_div">
                                <Button @click="click_detail(row, 0)" size="small" type="primary"
                                    style="font-size: 12px;margin-left:3px">核算详情({{ row.people_count }}人)</Button>
                                <span @click="down_file(row)" class="file_down_span">
                                    <Icon type="ios-cloud-download-outline" />原表
                                </span>

                            </div>
                        </template>
                        <template #cesuan_finish_msg="{ row }">
                            <div @click='view_msg(row)' class="view_msg1" v-if="row.cesuan_status == 2">
                                {{ row.cesuan_finish_msg ? '失败,' + row.cesuan_finish_msg.substring(0, 8) : '完成' }}
                                <Icon v-if="row.cesuan_finish_code != 1 && row.cesuan_finish_code != 0"
                                    :title="row.cesuan_finish_msg" class="viewmsg" type="md-alert" color="red"
                                    size="18" />
                            </div>
                            <div v-else>请等待任务结束</div>

                        </template>
                        <template #sixty_count_fmt="{ row }">
                            <div v-if="row.sixty_count > 0" class="sixty_count_fmt" @click="click_sixty(row)">
                                {{ row.sixty_count_fmt }}
                                <Icon :title="row.sixty_count_fmt" class="viewmsg" type="md-alert" color="red"
                                    size="18" />
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>

                    </Table>

                </div>
            </div>
            <!-- <div class="divright">
                <iframe :src="tips_url" style="width:100%;height:calc(100% - 7px) " frameborder="0"></iframe>
            </div> -->
        </div>

        <Modal v-model="teaching_show" title="个税核算功能教学" :mask-closable="false" :footer-hide="true" :closable="true"
            width="85%">
            <div class="teaching_modal">
                <iframe :src="tips_url" style="width:100%;height:calc(100% - 7px) " frameborder="0"></iframe>
            </div>

        </Modal>


        <Modal v-model="change_name_show" title="改名员工报备" :mask-closable="false" :footer-hide="true" :closable="true"
            width="500">
            <div class="change_name_tishi">
                报备后正常提交，测算表使用员工旧名字测算
            </div>
            <div>
                <div class="change_name_input">
                    旧姓名：
                    <Input v-model="change_name_item.old_name" placeholder="请输入员工旧姓名" style="width: 300px" />
                </div>
                <div class="change_name_input">
                    新姓名：
                    <Input v-model="change_name_item.new_name" placeholder="请输入员工新姓名" style="width: 300px" />
                </div>
                <div class="change_name_input">
                    身份证号：
                    <Input v-model="change_name_item.idcard" placeholder="请输入18位身份证号码" style="width: 300px" />
                </div>
            </div>
            <div class="add_people_div">
                <Button @click="add_change_people" type="primary">确认报备</Button>
            </div>
        </Modal>


        <Drawer title="个税核算详情" :closable="true" v-model="cesuan_detail_show" width="95">
            <Spin fix v-if="detail_loading">加载中...</Spin>
            <div>
                <div class="export_div">
                    <div class="export_btn" @click="export_detail_xls">
                        <Icon type="ios-cloud-download-outline" />导出核算后表格
                    </div>
                </div>

                <div>
                    <Table :height="windowHeight - 130" ref="table2" size="small" :columns="columns2" show-summary
                        :data="table_data2">
                    </Table>
                </div>

            </div>
        </Drawer>



        <Modal v-model="upload_show" title="文件上传" :mask-closable="false" :footer-hide="true" :closable="false"
            width="400">
            <div>
                <div>
                    正在上传中，请稍等
                </div>
            </div>
        </Modal>

        <Modal v-model="upload_error_show" title="文件上传异常提示" :mask-closable="false" :footer-hide="true" :closable="true"
            width="600">
            <div>
                <div v-for="(item, i) in error_list" class="error_line">
                    {{ item.msg }}
                </div>
            </div>
        </Modal>

        <Modal v-model="cesuan_finish_msg_show" title="任务结束-状态详情" :mask-closable="false" :footer-hide="true"
            :closable="true" width="600">
            <div class="img_miaoshu" v-if="cesuan_finish_item.back_img">
                图片描述：
                <div @click="view_back_img(cesuan_finish_item.back_img)">
                    <img :src="cesuan_finish_item.back_img" alt="" style="width:80px;height:40px;" class="back_img1">
                </div>
            </div>
            <div class="finish_msg3">
                {{ cesuan_finish_item.cesuan_finish_msg }}
            </div>
        </Modal>

        <Modal v-model="sixty_show" title="算个税重要提示" ok-text="导出未算数据" @on-ok="download_sixty_data">
            <div> {{ sixty_down_item.sixty_name_list }} </div>
            <div class="sixty_span">以上人员是按年6万额扣除个税，无法自动算税，请联系财务手动计算这几个人的数据，其余数据计算完毕，可正常使用。</div>
        </Modal>

        <Modal :closable='false' :mask-closable="false" v-model="tips_show" title="检测到当月已经核算过,收入需要合并的提示"
            ok-text="我重新调整模板数据" cancel-text="仍要提交" @on-ok="tips_ok" @on-cancel="tips_cancel" width="80">
            <div class="tips_span">
                以下人员本月已经多次核算，每月多次发薪的，算税时需合并收入，如有特殊情况可忽略。不理解请先问下财务不要乱操作哟！😰😰😰
            </div>
            <div class="tips_div">
                <div v-for="(item, i) in tips_list" :key="i" class="tips_list">
                    {{ i + 1 }}、 {{ item }}
                </div>
            </div>

        </Modal>

    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { download_file, get_view_file_url, http, open_new_page } from "@/utils/http.js";

export default {
    components: {
        my_menu2,
    },
    data() {



        return {
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度
            project_id: '',
            project_name: "",
            upload_url: '',
            upload_show: false,
            template_name: "",
            template_url: '',
            subject_data: [],
            select_subject: [],
            upload_object_name: '',
            upload_file_filename: '',
            upload_error_show: false,
            error_list: [],
            cesuan_id: '',
            suanshui_loading: false,
            year_month: '',
            year: 0,
            month: 0,
            columns: [],
            table_data: [],
            columns2: [],
            table_data2: [],
            cesuan_detail_show: false,
            cesuan_finish_msg_show: false,
            cesuan_finish_item: {},
            sixty_show: false,
            sixty_down_item: {},
            export_object_name: '',
            detail_row_item: {},
            detail_loading: false,
            tips_show: false,
            tips_list: [],
            tips_url: 'https://www.yuque.com/ck47/dx/bo9enz3qrfe8vy78?singleDoc# 《员工个税线上核算功能教学》',
            change_name_show: false,
            change_name_item: {
                new_name: "",
                old_name: "",
                idcard: ""
            },

            teaching_show: true,
            cesuan_type: "工资薪金",
            template_nzj_url: "",
            template_lwbc_url: ""



        }
    },
    mounted() {
        var query = this.$route.query
        this.project_id = query.project_id
        this.project_name = query.project_name
        this.getCurrentMonthFirstDay();

        this.get_project_suanshui_record()

        this.get_template()
        this.get_subject_data()
    },
    methods: {

        add_change_name_people() {
            this.change_name_show = true
        },

        export_detail_xls() {
            this.click_detail(this.detail_row_item, 1)
            // this.$refs.table2.exportCsv({
            //     filename: '核算结果导出'
            // });
        },
        click_detail(row, is_download) {
            this.table_data2 = []
            this.columns2 = []
            this.detail_row_item = row
            var that = this;
            if (is_download == 1) {
                this.$Message.info('正在导出，请稍等')
            }
            that.cesuan_detail_show = true
            that.detail_loading = true
            var obj = {
                cesuan_id: this.detail_row_item.cesuan_id,
                is_download: is_download
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/suanshui_detail", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns2 = res.data.columns
                        that.detail_loading = false
                        that.table_data2 = res.data.table_data
                        that.export_object_name = res.data.object_name
                        if (that.export_object_name != '' && is_download == 1) {
                            get_view_file_url(that.export_object_name)
                        }
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        get_project_suanshui_record() {
            var that = this;
            var obj = {
                project_id: this.project_id
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/project_suanshui_record", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns
                        that.table_data = res.data.table_data
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        cesuan_type_change(e) {
            console.log(this.cesuan_type)
            this.upload_url = process.env.VUE_APP_HOST +
                "/finance/itax/upload_itax_file?token=" +
                this.$cookies.get("dx_token") + '&project_id=' + this.project_id + '&subject_id=' + this.select_subject[0] + '&taxation_id=' + this.select_subject[1] + "&year=" + this.year + '&month=' + this.month + '&cesuan_type=' + this.cesuan_type
        },

        cascader_change(e) {
            console.log(e)
            this.select_subject = e
            this.upload_url = process.env.VUE_APP_HOST +
                "/finance/itax/upload_itax_file?token=" +
                this.$cookies.get("dx_token") + '&project_id=' + this.project_id + '&subject_id=' + this.select_subject[0] + '&taxation_id=' + this.select_subject[1] + "&year=" + this.year + '&month=' + this.month + '&cesuan_type=' + this.cesuan_type
        },

        get_subject_data() {
            var that = this;
            var obj = {
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/itax_subject_data", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.subject_data = res.data.subject_data
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        click_download_template(status) {
            if (status == 0) {
                get_view_file_url(this.template_url)
            }
            if (status == 1) {
                get_view_file_url(this.template_nzj_url)
            }

            if (status == 2) {
                get_view_file_url(this.template_lwbc_url)
            }

        },

        down_file(row) {
            get_view_file_url(row.file)
        },

        click_suanshui() {
            var that = this
            this.$Modal.confirm({
                title: '算税提交小提示',
                content: '<p>当前项目:【' + this.project_name + '】⚠️⚠️，你正在为【' + this.project_name + '】提交个税算税数据，请核对所属项目是否与上传的文件匹配，按项目对应上传，不要上传错了哟~😀</p>',
                onOk: () => {
                    that.click_suanshui_request()
                },
                onCancel: () => {

                }
            });
        },
        click_suanshui_request() {
            this.suanshui_loading = true
            var that = this;

            if (this.year == 0 || this.month == 0) {
                this.$Message.error('年月出错')
                return
            }

            var obj = {
                cesuan_id: this.cesuan_id,
                year: this.year,
                month: this.month,
                object_name: this.upload_object_name
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/geshui_hesuan", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_project_suanshui_record()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.suanshui_loading = false
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        get_template() {
            var that = this;
            var obj = {
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/itax_template", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.template_url = res.data.url
                        that.template_nzj_url = res.data.url_nzj
                        that.template_lwbc_url = res.data.url_lwbc
                        that.template_name = res.data.name
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        upload_progress(e) {
            this.upload_show = true
        },
        upload_error(e) {
            this.upload_show = false
            this.$Message.error('上传失败')
        },

        tips_ok() {
            this.upload_object_name = ''
            this.upload_file_filename = ''
            this.cesuan_id = ''
        },
        tips_cancel() {
            var that = this
            this.$Modal.confirm({
                title: '提示',
                okText: '我清楚后果',
                cancelText: '我不清楚',
                content: '<p>请确认知晓此操作带来的后果，确认要继续吗？</p>',
                onOk: () => {
                    this.tips_show = false

                },
                onCancel: () => {
                    this.upload_object_name = ''
                    this.upload_file_filename = ''
                    this.cesuan_id = ''
                }
            });
        },
        success_upload(e) {
            this.upload_show = false
            console.log(e)
            if (e.code == 0) {
                this.$Message.success(e.msg)
                this.tips_list = e.data.tips_list;
                this.upload_object_name = e.data.object_name
                this.upload_file_filename = e.data.filename
                this.cesuan_id = e.data.cesuan_id
                if (this.tips_list.length > 0) {
                    this.tips_show = true
                }
                // var divlist = ''
                // for(var i =0;i<e.data.tips_list.length;i++){
                //     divlist += '<div>'+e.data.tips_list[i]+'</div>'
                // }


                // if (this.tips_list.length > 0) {
                //     this.$Modal.confirm({
                //         title: '当月已经测算过的小提示',
                //         content: '<div>'+divlist+'<div>收入未合并，测算时个税数据会不准确，是否要继续提交吗？</div></div>',
                //         onOk: () => {
                //             this.$Message.info('Clicked ok');
                //         },
                //         onCancel: () => {
                //             this.$Message.info('Clicked cancel');
                //         }
                //     });

                // } else {
                //     this.upload_object_name = e.data.object_name
                //     this.upload_file_filename = e.data.filename
                //     this.cesuan_id = e.data.cesuan_id
                // }

            } else {
                this.$Message.error(e.msg)
                this.error_list = e.data.error_list
                this.cesuan_id = ''
                if (this.error_list.length > 0) {
                    this.upload_error_show = true
                }
            }
        },

        click_upload_file() {
            get_view_file_url(this.upload_object_name)

        },
        del_upload_file() {
            this.upload_object_name = ''
            this.upload_file_filename = ''
            this.cesuan_id = ''
        },
        getCurrentMonthFirstDay() {
            const now = new Date();
            const year = now.getFullYear();
            this.year = year
            const month = now.getMonth() + 1; // 月份从0开始，所以+1
            this.month = month
            this.year_month = `${year}-${month.toString().padStart(2, '0')}-01`;
        },
        view_msg(row) {
            this.cesuan_finish_msg_show = true

            this.cesuan_finish_item = row

        },
        view_back_img(url) {
            this.$ImagePreview.show({
                previewList: [url]
            });
        },
        click_sixty(item) {

            this.sixty_down_item = item
            this.sixty_show = true

            // var sixty_name_list = item.sixty_name_list
            // const str2 = sixty_name_list.join();
            // this.$Modal.confirm({
            //     title: '提示',
            //     content: '<div>' + str2 + '</div><div>以上人员是按年6万额扣除个税，无法自动算税，请联系财务手动计算这几个人的数据，其余数据计算完毕，可正常使用。</div>',
            //     onOk: () => {

            //     },
            //     onCancel: () => {

            //     }
            // });

        },
        add_change_people() {
            var that = this;
            var obj = {
                old_name: this.change_name_item.old_name,
                new_name: this.change_name_item.new_name,
                idcard: this.change_name_item.idcard,
                project_id: this.project_id
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/change_name_people_add", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        that.change_name_show = false
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        download_sixty_data() {
            var that = this;
            var obj = {
                sixty_id_list: this.sixty_down_item.sixty_id_list
            };
            http("post", process.env.VUE_APP_HOST + "/finance/itax/download_sixty_xls", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        var object_name = res.data.object_name
                        get_view_file_url(object_name)

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },


    }
}
</script>

<style scoped>
.teaching_modal {
    height: 70vh;
    width: calc(85vw - 30px);
    background-color: #ccc;
}

.add_people_div {
    display: flex;
    justify-content: end;
    margin-top: 10px;
}

.change_name_tishi {
    background-color: #15b04e;
    padding: 5px 10px;
    border-radius: 3px;
    color: #fff;
    margin-bottom: 10px;

}

.change_name_input {
    margin: 0 0 10px 0;
}

.title_record_left {
    display: flex;
    align-items: center;
}

.divmain {}

.divleft {
    /* width: calc(100vw - 360px) */
}

.divright {
    border-left: 1px solid #ccc;
    width: 350px;
    height: calc(100vh - 50px);
    overflow: auto;
    flex-shrink: 0;
}

.tips_div {
    height: 400px;
    overflow: auto;
}

.tips_span {
    background: #ffd5d1;
    padding: 5px;
    color: #393939;
}

.tips_list {
    border-bottom: 1px solid #ececec;
    padding: 5px;
}

.detail_div {
    display: flex;
    align-items: center;
}

.sixty_span {
    margin-top: 10px;
    padding: 5px;
    border: 1px solid red;
    color: red;
}

.sixty_count_fmt:hover {
    font-weight: 600;
}

.sixty_count_fmt {
    color: red;
    cursor: pointer;
}

.back_img1:hover {
    border: 1px solid #0173ff;
    cursor: pointer;
}

.img_miaoshu {
    display: flex;

}


.img_miaoshu:hover {
    cursor: pointer;
    border: 2px solid #0173ff
}



.finish_msg3 {
    color: #666;
    font-size: 13px;
}

.view_msg1:hover {
    cursor: pointer;
    font-weight: 600;
    color: #333
}

.view_msg1 {
    color: #1163c8
}

.file_down_span {
    font-size: 12px;
    margin-left: 3px;
    cursor: pointer;
    color: #5e5e5e
}

.file_down_span:hover {
    color: #0173ff
}

.detail_div {
    display: flex;
    align-items: center;
}

.viewmsg {
    cursor: pointer;
}

.export_btn {
    color: #0466dd;
    cursor: pointer;
    padding-bottom: 3px;
}

.export_div {
    display: flex;
    justify-content: end;
}

.year_month_div {
    margin: 0 10px 10px 10px;
}

.submit_div {
    display: flex;
    justify-content: end;
    margin: 0px 10px;
}


.error_line {

    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #e5e4e4;
}

.view_upload_file {
    color: #0466dd;
    cursor: pointer;
}

.upload_object_card {
    border: 1px solid #ececec;
    padding: 10px;
    border-radius: 3px;

}

.select_cascader {
    padding: 0 10px;
}

.title_record {
    padding: 10px;
    font-weight: 600;
    border-top: 10px solid #f3f3f3;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title_icon {
    margin-right: 5px;
    width: 10px;
    border-radius: 3px;
    height: 17px;
    background-color: #1980ff;
}

.title_1 {
    padding: 10px;
    font-weight: 600;
}

.template_name {
    color: #0466dd;
    cursor: pointer;
}

.template_div {
    margin-left: 10px;
}

.upload_box {
    padding: 0 10px;
    display: flex;
    align-items: center;
}
</style>